// extracted by mini-css-extract-plugin
export var accordionStyling = "PriceCategoryComponent-module--accordionStyling--7ba9c";
export var categoryImage = "PriceCategoryComponent-module--categoryImage--6c2ff";
export var categoryKicker = "PriceCategoryComponent-module--categoryKicker--7b504";
export var categoryTitle = "PriceCategoryComponent-module--categoryTitle--ad176";
export var contentStyling = "PriceCategoryComponent-module--contentStyling--625c7";
export var headerHeadingContainer = "PriceCategoryComponent-module--headerHeadingContainer--fdb62";
export var priceCategory = "PriceCategoryComponent-module--priceCategory--18b5a";
export var priceContainer = "PriceCategoryComponent-module--priceContainer--a6333";
export var priceContainerClosed = "PriceCategoryComponent-module--priceContainerClosed--179b2";
export var priceContainerOpened = "PriceCategoryComponent-module--priceContainerOpened--ae7b2";
export var priceContent = "PriceCategoryComponent-module--priceContent--4363c";
export var pricePosition = "PriceCategoryComponent-module--pricePosition--d7123";
export var priceStyling = "PriceCategoryComponent-module--priceStyling--7ef8e";
export var subCategoryTitle = "PriceCategoryComponent-module--subCategoryTitle--369c6";